import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const RSSAPI = {
  getRSSFeed: async() =>
    (await initAxios())
      ?.get('/rss')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default RSSAPI;
